<template>
    <div>
      <p>{{ formattedTime }}</p>
    </div>
  </template>
   
  <script>
  export default {
    name: 'CountdownTimer',
    props: {
      endTime: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        timeLeft: 0
      };
    },
    computed: {
      formattedTime() {
        const days = String(Math.floor(this.timeLeft / 60 / 60 / 24)).padStart(2, '0');
        const hours = String(Math.floor(this.timeLeft / 60 / 60) % 24).padStart(2, '0');
        const minutes = String(Math.floor((this.timeLeft / 60) % 60)).padStart(2, '0');
        const seconds = String(Math.floor(this.timeLeft % 60)).padStart(2, '0');

        return days > 0 ? `${days}天${hours}时` : `${hours}:${minutes}:${seconds}`;
      }
    },
    methods: {
      startCountdown() {
        this.timeLeft = Math.floor((new Date(this.endTime) - new Date()) / 1000); // Convert to seconds
        if (this.timeLeft < 0) {
          this.timeLeft = 0; // Make sure time is not negative
          clearInterval(this.countdownInterval); // Stop the interval if time is up
        } else {
          this.timeLeft--; // Decrement time by 1 second
        }
      }
    },
    mounted() {
      this.countdownInterval = setInterval(this.startCountdown, 1000); // Update every second
    },
    beforeDestroy() {
      clearInterval(this.countdownInterval); // Clear interval when component is destroyed to prevent memory leaks
    }
  }
</script>